import gql from 'graphql-tag';

export const getWifiTests = gql`
  query ($applicationId: Int) {
    getWifiTests (application: $applicationId) {
       wifiTestId
       startTime
       endTime
       noOfRequests
	     noOfServerError
	     noOfNoResponseError
	     noOfRequestError
    }
  }
`
